import { lazy } from "react";
import { Col } from "antd";
import { Content } from "../../components/MiddleBlock/styles";
import IntroContent from "../../content/IntroContent.json";
// TODO single index.ts exporting all content from ../../content
import CustomerReviewsContent from "../../content/CustomerReviewsContent.json";
import AboutContent from "../../content/AboutContent.json";
import ServicesContent from "../../content/ServicesContent.json";
import ContactContent from "../../content/ContactContent.json";
// import ImageBanner from "../../components/ImageBanner";
// import QuiltedImageList from "../../components/ImageList";
import MiddleBlock from "../../components/MiddleBlock";
import Contact from "../../components/ContactForm";
import Container from "../../common/Container";
import { primaryAccentColor, primaryHeaderColor } from "../../styles";
import ReviewContainer from "../../components/ReviewContainer";
import Gallery from "../../components/Gallery";
import Box from "@mui/material/Box";

// const Contact = lazy(() => import("../../components/ContactForm"));
// const MiddleBlock = lazy(() => import("../../components/MiddleBlock"));
// const Container = lazy(() => import("../../common/Container"));
const ScrollToTop = lazy(() => import("../../common/ScrollToTop"));
// const ContentBlock = lazy(() => import("../../components/ContentBlock"));

const Home = () => {
  return (
    <Container>
      <ScrollToTop />
      {/* <ImageBanner /> */}
      <br />
      <br />
      {/* <MiddleBlock
        // type="right"
        title={IntroContent.title}
        content={IntroContent.text}
        button={IntroContent.button}
        // icon="developer.svg"
        id="intro"
      /> */}
      <MiddleBlock
        title=""
        content=""
        button=""
        custom={
          <Col lg={24} md={24} sm={24} xs={24}>
            <h6
              id="intro"
              style={{
                fontFamily: "'seasons', 'Motiva Sans Bold', 'serif'",
                fontWeight: "bold",
                color: primaryHeaderColor,
              }}
            >
              {IntroContent.title}
            </h6>
            <Content>
              <p
                style={{
                  color: primaryAccentColor,
                }}
              >
                We're so glad you're here! At Heart of Life Floral, we are
                passionate about working with quality flowers to create
                beautiful pieces that add even more joy and warmth to your big
                event. Whether you're celebrating a wedding, shower, or special
                occasion, our arrangements showcase nature's happiest creation.
              </p>
              <br />
              <p
                style={{
                  color: primaryAccentColor,
                  fontStyle: "italic",
                }}
              >
                Because flowers are reminders that the Heart of Life is good.
              </p>
            </Content>
          </Col>
        }
        id="intro"
      />
      <MiddleBlock
        // type="left"
        title={AboutContent.title}
        content={AboutContent.text}
        button={AboutContent.button}
        img="https://dwxmfgxgcusc8.cloudfront.net/about-section/about-photo.jpg"
        // section={AboutContent.section}
        // icon="graphs.svg"
        id="about"
      />
      <MiddleBlock
        // type="left"
        title="Heart of Life Campaign"
        content="2025 Spotlight - Junie's Place"
        button=""
        img="https://images.squarespace-cdn.com/content/v1/664a15c38848e475b3fda081/d3c52730-ee0b-4423-af8b-464b0b4a8c2d/JPLogo2.png"
        // section={AboutContent.section}
        // icon="graphs.svg"
        custom={
          <Col lg={24} md={24} sm={24} xs={24}>
            <h6
              id="campaign"
              style={{
                fontFamily: "'seasons', 'Motiva Sans Bold', 'serif'",
                fontWeight: "bold",
                color: primaryHeaderColor,
              }}
            >
              Heart of Life Campaign
            </h6>
            <p
              style={{
                color: primaryHeaderColor,
                fontSize: "2.5em",
              }}
            >
              2025 spotlight - Junie's Place
            </p>
            <Content>
              <Box
                component="img"
                sx={{
                  display: "block",
                  overflow: "hidden",
                  marginRight: "auto",
                  marginLeft: "auto",
                  borderRadius: "100%",
                  width: "100%",
                }}
                src="https://images.squarespace-cdn.com/content/v1/664a15c38848e475b3fda081/d3c52730-ee0b-4423-af8b-464b0b4a8c2d/JPLogo2.png"
                alt="Junie's Place Logo"
              />
              <p
                style={{
                  color: primaryAccentColor,
                }}
              >
                We're excited to announce the 2025 Heart of Life campaign!
              </p>
              <p
                style={{
                  color: primaryAccentColor,
                }}
              >
                Each year Heart of Life Floral selects an organization close to
                our heart to contribute a portion of the year's sales. For the
                2025 year, we will be donating a percentage of all bouquet sales
                to Junie's Place. In honor of Junie, Junie's Place is dedicated
                to providing no-cost bereavement support to families who have
                experienced child loss - to create a community where no families
                grieve alone.
              </p>
              <p
                style={{
                  color: primaryAccentColor,
                }}
              >
                We believe that the Heart of Life is good and we're so happy to
                support Junie's Place doing good work! Find out more about
                Junie's Place and support their mission at{" "}
                <a href="https://www.juniesplace.org" target="_blank">
                  www.juniesplace.org
                </a>
                .
              </p>
              <p
                style={{
                  color: primaryAccentColor,
                }}
              >
                Instagram:{" "}
                <a
                  href="https://www.instagram.com/vilomomma?igsh=YnZqemV1aWJlNjBt"
                  target="_blank"
                >
                  @vilomomma
                </a>
              </p>
              <p
                style={{
                  color: primaryAccentColor,
                }}
              >
                Facebook:{" "}
                <a
                  href="https://www.facebook.com/share/15obCjV38L/?mibextid=wwXIfr"
                  target="_blank"
                >
                  Junie's Place, Inc.
                </a>
              </p>
            </Content>
          </Col>
        }
        id="campaign"
      />

      <MiddleBlock
        // type="right"
        // title={ServicesContent.title}
        // content={ServicesContent.text}
        // button={ServicesContent.button}
        title=""
        content=""
        button="" // TODO add in button
        // icon="product-launch.svg"
        custom={
          <Col lg={24} md={24} sm={24} xs={24}>
            <h6
              id="services"
              style={{
                fontFamily: "'seasons', 'Motiva Sans Bold', 'serif'",
                fontWeight: "bold",
                color: primaryHeaderColor,
              }}
            >
              {ServicesContent.title}
            </h6>
            <Content>
              <p
                style={{
                  color: primaryAccentColor,
                }}
              >
                {ServicesContent.text}
              </p>
            </Content>
            {/* Weddings */}
            <p
              style={{
                color: primaryHeaderColor,
                fontSize: "2.5em",
              }}
            >
              Weddings
            </p>
            <Content>
              <p
                style={{
                  color: primaryAccentColor,
                }}
              >
                Congratulations on a beautiful milestone! Heart of Life Floral
                has been specializing in weddings since our start! When hiring a
                florist for your big day, it's so important to work with a
                florist who specializes in weddings. Wedding florists understand
                timelines, moving parts, collaboration with all vendors,
                prioritizing the bride/groom, and the importance of the details!
                Whether it's important to you to highlight the bride's favorite
                florals or honoring Grandma by incorporating her favorite
                flower, a wedding florist understands that these small things
                are actually the big things during such a momentous life event.
                Our priority is to be on the same page with you every step of
                the way and make your dream wedding a reality! We don't believe
                in cookie cutter weddings and want to work with you to make your
                big day special and uniquely YOU!
              </p>
            </Content>
            {/* Rentals */}
            <p
              style={{
                color: primaryHeaderColor,
                fontSize: "2.5em",
              }}
            >
              Rentals
            </p>
            <Content>
              <p
                style={{
                  color: primaryAccentColor,
                }}
              >
                We love a DIY'er! At heart of life floral, we're happy to rent
                glassware for your big events at a fraction of the price so you
                don't have to worry about storing or reselling bulky items!
              </p>
              <p
                style={{
                  color: primaryAccentColor,
                }}
              >
                Delivery and pickup within New England +$50
              </p>
              <p
                style={{
                  color: primaryAccentColor,
                }}
              >
                Avoid delivery fees by picking up and returning to one of 2
                convenient New England locations - Acton MA or Gray ME
              </p>
              <p
                style={{
                  color: primaryAccentColor,
                }}
              >
                See glassware rental options - coming soon!
              </p>
            </Content>
            {/* Wedding Bundles */}
            {/* <h6
              id="wedding-bundles"
              style={{
                fontFamily: "'seasons', 'Motiva Sans Bold', 'serif'",
                fontWeight: "bold",
                color: primaryHeaderColor,
              }}
            > */}
            <p
              style={{
                color: primaryHeaderColor,
                fontSize: "2.5em",
              }}
            >
              Wedding Bundles
            </p>
            <Content>
              <p
                style={{
                  color: primaryAccentColor,
                }}
              >
                Coming soon!
              </p>
            </Content>
          </Col>
        }
        id="services"
      />
      {/* TODO move to json files */}
      {/* TODO fix up custom option instead of passing it in */}
      {/* Price transparency */}
      <MiddleBlock
        title=""
        content=""
        button=""
        custom={
          <Col lg={24} md={24} sm={24} xs={24}>
            <h6
              id="pricing"
              style={{
                fontFamily: "'seasons', 'Motiva Sans Bold', 'serif'",
                fontWeight: "bold",
                color: primaryHeaderColor,
              }}
            >
              Pricing
            </h6>
            <Content>
              <p
                style={{
                  color: primaryAccentColor,
                }}
              >
                We strongly believe in the importance of price transparency. We
                want to work with you to meet your budget needs - because
                everyone deserves beautiful, quality flowers on their wedding
                day! It's why we got into this work! Our tiered pricing guide
                helps to ensure that we are meeting your vision and staying
                within your budget.
              </p>
              <p
                style={{
                  color: primaryHeaderColor,
                  fontSize: "1.5em",
                }}
              >
                Tiered pricing
              </p>
              <div
                style={{
                  textAlign: "left",
                  marginBottom: "2%",
                  color: primaryAccentColor,
                }}
              >
                <span style={{ fontWeight: "bold" }}>Tier 1</span> - the “I want
                simple” bride - budget $1500-$3000
              </div>
              <div
                style={{
                  textAlign: "left",
                  marginBottom: "2%",
                  color: primaryAccentColor,
                }}
              >
                <span style={{ fontWeight: "bold" }}>Tier 2</span> - the
                “Florals are one of many priorities” bride - budget $3000-$5000
              </div>
              <div
                style={{
                  textAlign: "left",
                  marginBottom: "2%",
                  color: primaryAccentColor,
                }}
              >
                <span style={{ fontWeight: "bold" }}>Tier 3</span> - the “I love
                florals!” bride - budget $5000+
              </div>
              <br />
              <p
                style={{
                  color: primaryAccentColor,
                  fontStyle: "italic",
                }}
              >
                Design guide - coming soon!
              </p>
            </Content>
          </Col>
        }
        id="price-transparency"
      />
      {/* <QuiltedImageList /> */}
      <Gallery />
      <MiddleBlock
        // title={CustomerReviewsContent.title}
        // content={CustomerReviewsContent.text}
        // button={CustomerReviewsContent.button}
        title=""
        content=""
        button=""
        custom={
          <Col lg={24} md={24} sm={24} xs={24}>
            <h6
              id="reviews-header"
              style={{
                fontFamily: "'seasons', 'Motiva Sans Bold', 'serif'",
                fontWeight: "bold",
                color: primaryHeaderColor,
              }}
            >
              {CustomerReviewsContent.title}
            </h6>
            <Content>
              <ReviewContainer />
            </Content>
          </Col>
        }
        id="reviews"
      />
      <Contact
        title={ContactContent.title}
        content={ContactContent.text}
        id="contact"
      />
    </Container>
  );
};

export default Home;
